import { MicrophoneMessageOffIcon } from './MicrophoneMessageOffIcon';

/**
 * author: Austin Andrews
 * id 1AE8F7A9-5454-44D2-B16D-1D383E33978D
 * name microphone-message-off
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/microphone-message-off.svg
 * tags
 */
export const TextToSpeechOffIcon = MicrophoneMessageOffIcon;
export default TextToSpeechOffIcon